import { riscoConfig } from "@/mocks/cta";

interface TreeRiskBadgeProps {
  risco: string;
  size?: "sm" | "md";
}

export default function TreeRiskBadge({ risco, size = "sm" }: TreeRiskBadgeProps) {
  const cfg = riscoConfig[risco] || { badge: "bg-background-100 text-foreground-500", label: risco };
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span className={`badge ${sizeClass} ${cfg.badge}`}>{cfg.label}</span>
  );
}